import type { SparkReferenceValue } from 'types/SparkStepReference';

const insertReferenceInCodePanel = (
  lastFocusedElement: HTMLElement,
  reference: SparkReferenceValue
) => {
  const cmLine =
    lastFocusedElement.closest('.cm-line') ||
    lastFocusedElement.querySelector('.cm-line');
  if (!cmLine) {
    return;
  }
  // const selection = getSelection()
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return;
  const range = selection.getRangeAt(0);
  let cursorNode = range.startContainer;
  let cursorOffset = range.startOffset;
  // Ensure we are inside `.cm-line`
  if (!cmLine.contains(cursorNode)) return;

  // Get the original text
  const originalText = cursorNode.textContent || '';

  // Insert new value at cursor position
  const updatedText =
    originalText.slice(0, cursorOffset) +
    reference.reference +
    originalText.slice(cursorOffset);

  // Replace the text content
  cursorNode.textContent = updatedText;

  // Normalize to merge text nodes
  cmLine.normalize();

  // Move cursor to the end of the inserted text
  // requestAnimationFrame(() => {
  //   const newCursorPos = cursorOffset + reference.reference.length;
  //   const newRange = document.createRange();
  //   newRange.setStart(cursorNode, newCursorPos);
  //   newRange.collapse(true);

  //   selection.removeAllRanges();
  //   selection.addRange(newRange);
  // });

  return;
};

const insertReferenceInTextField = (
  lastFocusedElement: HTMLTextAreaElement,
  reference: SparkReferenceValue
) => {
  const { selectionStart, selectionEnd, value } = lastFocusedElement;
  lastFocusedElement.value =
    value.substring(0, selectionStart) +
    reference.reference +
    value.substring(selectionEnd);

  const newCursorPosition = selectionStart + reference.reference.length;
  lastFocusedElement.setSelectionRange(newCursorPosition, newCursorPosition);

  lastFocusedElement.focus();
  lastFocusedElement.blur();
};

export const useNodeSpecificOperations = () => {
  return { insertReferenceInCodePanel, insertReferenceInTextField };
};
